<template>
	<div class="body" :style="{'padding-top':height?'0':top+'px','height':height?'100%':'auto'}">
		<el-image class="img" :src="require('@/static/img-nodata.png')"  fit="cover"></el-image>
		<div class="text">{{text}}</div>
	</div>
</template>

<script>
	export default {
		name:"noData",
		data() {
			return {
				
			};
		},
		props:{
			height:{
				type:Boolean,
				default:false,
			},
			top:{
				type:[String,Number],
				default:100,
			},
			text:{
				type:String,
				default:'暂无数据'
			}
		}
	}
</script>

<style lang="scss" scoped>
	.body{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		.img{
			width: 150px;
			height: 114px;
		}
		.text{
			margin-top: 26px;
			color: #666;
			font-size: 14px;
		}
	}
</style>